import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import api from 'api';
import { setCurrentView } from 'store';
import modules from 'modules';

import ErrorBoundary from 'partials/ErrorBoundary';
import Footer from 'partials/Footer';
import CookieNotice from 'partials/CookieNotice';
import Media from 'css/Media';

export class DiningPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allHotels: [],
            hotels: [],
        };
    }

    componentDidMount() {
        this.props.setCurrentView(null);
        this.preparePage();
    }

    componentDidUpdate(nextProps) {
        if(nextProps.match.params.slug != this.props.match.params.slug) {
            this.preparePage();
        }
    }

    preparePage = () => {
        window.scrollTo(0, 0);
        api.pageFetcher.getBySlug({ slug: this.props.match.path.replace('/en/', '') })
            .then(resp => {
                let page = resp.data[0];
                this.props.setCurrentView(page);
            })
    }

    render() {
        const { page } = this.props;
        if(!page) return null;
        
        return (
            <Wrapper>
                <Modules>
                    <ErrorBoundary for="Dining Builder">
                        {page && page.acf.modules && page.acf.modules.map((module, i) => {
                            return (
                                <div key={i} className={'module-'+module.acf_fc_layout}>
                                    {React.createElement(modules[module.acf_fc_layout], { data: module })}
                                </div>
                            )
                        })}
                    </ErrorBoundary>
                </Modules>
                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>
                <CookieNotice />
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    page: state.currentView,
});

const actions = {
    setCurrentView,
};

export default connect(mapStateToProps, actions)(withRouter(DiningPage));


const Wrapper = styled.section`
    scroll-behavior: smooth;
    width: 100%;
    padding-top: 120px;

    .container {
    }
    
    ${ Media.greaterThan('s')`
        padding-top: 220px;
    ` }  
`

const Modules = styled.section`
    h1 {
        font-weight: 400;
    }
    padding-bottom: ${props => props.theme.spacing.blockS};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXL};
    `}
`